var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.371 15.827L16.211 13.031L15.585 12.404L13.371 14.587L12.416 13.612L11.789 14.244L13.371 15.827ZM2.77 4.731H13.232V3.731H2.769L2.77 4.731ZM14 18.116C12.886 18.116 11.941 17.7277 11.165 16.951C10.3883 16.175 10 15.23 10 14.116C10 13.002 10.3883 12.0567 11.165 11.28C11.9417 10.5033 12.8867 10.1153 14 10.116C15.1133 10.1167 16.0587 10.5047 16.836 11.28C17.6133 12.0553 18.0013 13.0007 18 14.116C18 15.2293 17.612 16.1743 16.836 16.951C16.0587 17.7277 15.1133 18.116 14 18.116ZM0 16.769V0H16V7.56C15.8373 7.5 15.676 7.44867 15.516 7.406C15.3553 7.36333 15.1833 7.33 15 7.306V1H1V15.05H7.344C7.38933 15.3233 7.448 15.5907 7.52 15.852C7.59267 16.1133 7.69367 16.3627 7.823 16.6L7.789 16.634L6.654 15.808L5.308 16.769L3.962 15.808L2.616 16.769L1.269 15.808L0 16.769ZM2.77 12.269H7.479C7.51633 12.0857 7.56233 11.914 7.617 11.754C7.67167 11.594 7.73567 11.4323 7.809 11.269H2.77V12.269ZM2.77 8.5H10.08C10.4067 8.242 10.7567 8.027 11.13 7.855C11.5033 7.68233 11.9023 7.564 12.327 7.5H2.769L2.77 8.5Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderLight);
export default __webpack_public_path__ + "static/media/order-light.04ee65d26f8cae8659e0364940bfb471.svg";
export { ForwardRef as ReactComponent };